import React from 'react';
import {
  Page,
  Text,
  Image,
  Document,
  StyleSheet,
  View,
  Font,
} from '@react-pdf/renderer';
import { useNavigate } from 'react-router-dom';
import addCommas from '../../utils/functions/commas';
import dayjs from 'dayjs';
import { ExpandMore } from '@mui/icons-material';
// import { Font } from '../../../public/Font/THSarabunNew/__MACOSX';

Font.register({
  family: 'THSarabunNew',
  src: require('../../assets/THSarabunNew.ttf'),
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    width: 120,
  },
  data: {
    fontSize: 12,
    margin: 5,
    color: 'green',
    // fontFamily: 'Arial',
  },

  dataTH: {
    fontWeight: 'bold',
    fontSize: 20,
    margin: 0,
    color: 'green',
    marginLeft: 3,
    // fontFamily: 'Arial',
    fontFamily: 'THSarabunNew',
  },
  dataTHinet: {
    fontWeight: 'bold',
    fontSize: 20,
    margin: 0,
    color: 'black',
    marginLeft: 5,
    // fontFamily: 'Arial',
    fontFamily: 'THSarabunNew',
  },

  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 19,
    marginBottom: 20,
    textAlign: 'center',
    color: 'black',
    fontWeight: 700,
    //  fontFamily: "AntonFamily",
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',

    //  fontFamily: "AntonFamily",
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 7,
    marginTop: 5,
    fontSize: 12,
  },
  section: {
    textAlign: 'right',
    margin: 30,
    marginTop: 80,
    flexDirection: 'column',
  },
  textTitle: {
    color: 'green',
    fontWeight: 900,
  },
  textValue: {
    width: '50%',
  },
  content: {
    padding: 20,
    justifyContent: 'flex-end',

    marginTop: 20,

    flexDirection: 'row',
  },
  block: {
    width: '120%',
    textAlign: 'right',
    fontSize: 14,
  },
  blockData: {
    height: 100,
    width: '50%',
    textAlign: 'right',
    fontSize: 14,
  },
  test: {
    // fontSize:24,
    fontWeight: 'heavy',
  },
  titleTrans: {
    flexDirection: 'row',
  },

  textToltal: {
    // fontWeight: 900,
    color: 'red',
  },
});

function TransactionDetailPDF({ parsedArray }) {
  // console.log('props',props.param1);
  const pageColors = ['#f6d186', '#f67280', '#c06c84'];
  // console.log('data', test);
  console.log('parsedArray', parsedArray);

  return (
    <Document>
      return (
      <Page style={{ ...styles.body }}>
        <Text style={styles.header} fixed>
          {' '}
          Transaction Detail
        </Text>

        <view style={styles.titleTrans}>
          <Text style={styles.dataTHinet}>
            บริษัท อินเตอร์เน็ตประเทศไทย จำกัด (มหาชน)
          </Text>
        </view>
        <view style={styles.titleTrans}>
          <Text style={styles.dataTHinet}>
            1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT
          </Text>
        </view>
        <view style={styles.titleTrans}>
          <Text style={styles.dataTHinet}>
            ถ.เพชรบุรีตัดใหม่ แขวงบางกระปิ เขตห้วยขวาง กรุงเทพ 10310
          </Text>
        </view>
        <view style={styles.titleTrans}>
          <Text style={styles.text}>Company name </Text>
          <Text style={styles.dataTH}>
            {' '}
            {parsedArray?.customer?.customer_name}{' '}
          </Text>
        </view>
        <view style={styles.titleTrans}>
          <Text style={styles.text}>Transection Ref No. </Text>
          <Text style={styles.data}> {parsedArray?.order_id_ref} </Text>
        </view>

        <view style={styles.titleTrans}>
          <Text style={styles.text}>Service</Text>
          <Text style={styles.data}> {parsedArray?.description} </Text>
        </view>

        <view style={styles.titleTrans}>
          <Text style={styles.text}>To </Text>
          <Text style={styles.data}> {parsedArray?.customer?.sorgcode} </Text>
        </view>

        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Period No.</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Start Date</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>End Date</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Invice No.</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>data1</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {dayjs(parsedArray?.period_start_date).format('YYYY-MM-DD')}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {dayjs(parsedArray?.period_end_date).format('YYYY-MM-DD')}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {parsedArray?.invoice_description}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.content}>
          <View style={[styles.block]}>
            <Text>Total Amount (THB)</Text>
            <Text>VAT (THB)</Text>
            <Text>Withholding Tax (THB)</Text>
            <Text>Discount (THB)</Text>
            <Text>Fines (THB)</Text>
            <Text style={[styles.test]}>Grand Total (THB)</Text>
          </View>
          <View style={[styles.blockData]}>
            <Text>{addCommas(parsedArray?.total_amount)}</Text>
            <Text>{addCommas(parsedArray?.total_vat)}</Text>
            <Text>{addCommas(parsedArray?.total_wht)}</Text>
            <Text>{addCommas(parsedArray?.total_discount)}</Text>
            <Text>{addCommas(parsedArray?.total_fines)}</Text>
            <Text style={styles.textToltal}>
              {addCommas(parsedArray?.total_pay_amount)}
            </Text>
          </View>
        </View>

        {/* <View style={styles.section}>
        <View style={styles.textValue}> <Text >Total Amount (THB)</Text> </View>
        <view style={styles.textValue}><Text >data</Text></view>
          <Text style={styles.textTitle}>VAT (THB)</Text>
          <Text style={styles.textTitle}>Withholding Tax (THB)</Text>
          <Text style={styles.textTitle}>Fines (THB)</Text>
          <Text style={styles.textTitle}>Grand Total (THB)</Text>
        </View> */}

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
      </Page>
      )
    </Document>
  );
}

export default TransactionDetailPDF;
